import {FpdCtaRunner, FPD_CTA_FRAMES} from './FpdCtaRunner';
import {LalbaugchaRajaOverlays} from './LalbaugchaRajaOverlays';
import {NavratriDays13Overlays} from './NavratriDays13Overlays';
import {NavratriDays46Overlays} from './NavratriDays46Overlays';
import {NavratriDays79Overlays} from './NavratriDays79Overlays';
import {NeemKaroliBabaOverlays} from './NeemKaroliBabaOverlays';
import {KhadeHanumanUjjainOverlays} from './KhadeHanumanUjjainOverlays';
import {BadrinathOverlays} from './BadrinathOverlays';
import {UkhimathOverlays} from './UkhimathOverlays';
import {KarvaChauthOverlays} from './KarvaChauthOverlays';
import {ChaudahVarshOverlays} from './ChaudahVarshOverlays';
import {NavratriKathaOverlays} from './NavratriKathaOverlays';
import {MurtiZoomOut} from './MurtiZoomOut';
import "./index.css";
// ─── overlay_implementer auto-imports ───
import { BibleDecoderW01Overlays } from "./BibleDecoderW01Overlays";
import { BibleDecoderW02Overlays } from "./BibleDecoderW02Overlays";
import { BibleDecoderW03Overlays } from "./BibleDecoderW03Overlays";
import { JagannathFullPreview } from "./JagannathFullPreview";
import { CamphorFullPreview } from "./CamphorFullPreview";
import { FfuDamFullPreview } from "./FfuDamFullPreview";
import { MomosFullPreview } from "./MomosFullPreview";
import { MaggiFullPreview } from "./MaggiFullPreview";
import { MaggiSubCoverPreview } from "./MaggiSubCoverPreview";
import { MonsterEnergyFull } from "./MonsterEnergyFull";
import { StingFullPreview } from "./StingFullPreview";
import { SanatanDecodeGotraProof } from "./SanatanDecodeGotraProof";
import { SanatanDecodeGotraV2 } from "./SanatanDecodeGotraV2";
import { SanatanDecodeGotraV3 } from "./SanatanDecodeGotraV3";
import { SanatanDecodeGotraV4 } from "./SanatanDecodeGotraV4";
import { SanatanDecodeGotraV5 } from "./SanatanDecodeGotraV5";
import { SanatanDecodeGotraV6 } from "./SanatanDecodeGotraV6";
import { SanatanDecodeGotraV7 } from "./SanatanDecodeGotraV7";
import { SanatanDecodeGotraV8 } from "./SanatanDecodeGotraV8";
import { SanatanDecodeGotraV9 } from "./SanatanDecodeGotraV9";
import { SanatanDecodeGotraV10 } from "./SanatanDecodeGotraV10";
import { SanatanDecodeGotraV11 } from "./SanatanDecodeGotraV11";
import { SanatanDecodeGotraV12 } from "./SanatanDecodeGotraV12";
import { SanatanDecodeGotraV13 } from "./SanatanDecodeGotraV13";
import { SanatanDecodeGotraV14 } from "./SanatanDecodeGotraV14";
import { SanatanDecodeGotraV15 } from "./SanatanDecodeGotraV15";
import { SanatanDecodeGotraV16 } from "./SanatanDecodeGotraV16";
import { SanatanDecodeGotraV17 } from "./SanatanDecodeGotraV17";
import { SanatanDecodeGotraV18 } from "./SanatanDecodeGotraV18";
import { SanatanDecodeGotraV19 } from "./SanatanDecodeGotraV19";
import { VishnuSmritiFlow } from "./VishnuSmritiFlow";
import { GotraV20 } from "./gotra_v20/GotraV20";
// [2026-08-15] DISABLED: @remotion/three is NOT in the Modal image bundle -> webpack
// resolve error killed EVERY cluster render. Re-enable only after the HF bundle
// node_modules ships @remotion/three + three + @react-three/fiber.
// import { Gl3dSmoke } from "./Gl3dSmoke";
import { FontProbe } from "./sanatan45/FontProbe";
import { VerA_DeepField } from "./sanatan45/VerA_DeepField";
import { VerB_Archive } from "./sanatan45/VerB_Archive";
import { VerC_Type } from "./sanatan45/VerC_Type";
import { VerD_Delta } from "./sanatan45/VerD_Delta";
import { Gotra45 } from "./sanatan45/Gotra45";
// ── Factory Decoder CTAs (English, transparent) ──
import { CTASubscribeBell } from "./cta/CTASubscribeBell";
import { CTALike } from "./cta/CTALike";
import { CTAShare } from "./cta/CTAShare";
import { CTACombinedBar } from "./cta/CTACombinedBar";
import { CTALowerThird } from "./cta/CTALowerThird";

// ── Coca-Cola Factory Files Remotion Templates (81) ──
import AnimatedList from "./templates/animated-list";
import AnimatedText from "./templates/animated-text";
import AreaChart from "./templates/area-chart";
import BlindsTransition from "./templates/blinds-transition";
import BokehCircles from "./templates/bokeh-circles";
import BounceText from "./templates/bounce-text";
import BubblePopText from "./templates/bubble-pop-text";
import CameraShake from "./templates/camera-shake";
import CardFlip from "./templates/card-flip";
import ChapterTitle from "./templates/chapter-title";
import ChartAnimation from "./templates/chart-animation";
import CinematicTitleIntro from "./templates/cinematic-title-intro";
import CircularProgress from "./templates/circular-progress";
import ClockWipe from "./templates/clock-wipe";
import ComparisonChart from "./templates/comparison-chart";
import CountdownIntro from "./templates/countdown-intro";
import CountdownTimer from "./templates/countdown-timer";
import CreditsRoll from "./templates/credits-roll";
import CrossDissolve from "./templates/cross-dissolve";
import DonutChart from "./templates/donut-chart";
import EndCard from "./templates/end-card";
import FadeThroughBlack from "./templates/fade-through-black";
import FilmBurn from "./templates/film-burn";
import FloatingBubbleText from "./templates/floating-bubble-text";
import GalleryGrid from "./templates/gallery-grid";
import GeometricPatterns from "./templates/geometric-patterns";
import GlitchText from "./templates/glitch-text";
import GradientShift from "./templates/gradient-shift";
import GridPulse from "./templates/grid-pulse";
import ImageCarousel from "./templates/image-carousel";
import ImageComparisonSlider from "./templates/image-comparison-slider";
import ImageZoomReveal from "./templates/image-zoom-reveal";
import IrisTransition from "./templates/iris-transition";
import KenBurns from "./templates/ken-burns";
import LetterboxReveal from "./templates/letterbox-reveal";
import LineChart from "./templates/line-chart";
import LiquidWave from "./templates/liquid-wave";
import LogoBlurReveal from "./templates/logo-blur-reveal";
import LogoBounceDrop from "./templates/logo-bounce-drop";
import LogoFadeReveal from "./templates/logo-fade-reveal";
import LogoGlitchReveal from "./templates/logo-glitch-reveal";
import LogoScaleRotate from "./templates/logo-scale-rotate";
import LogoSpinReveal from "./templates/logo-spin-reveal";
import LogoSplitReveal from "./templates/logo-split-reveal";
import LogoStrokeDraw from "./templates/logo-stroke-draw";
import LogoTypewriter from "./templates/logo-typewriter";
import LowerThird from "./templates/lower-third";
import MasonryGallery from "./templates/masonry-gallery";
import MatrixRain from "./templates/matrix-rain";
import MorphTransition from "./templates/morph-transition";
import NoiseGrain from "./templates/noise-grain";
import NotificationPop from "./templates/notification-pop";
import ParallaxPan from "./templates/parallax-pan";
import ParticleExplosion from "./templates/particle-explosion";
import PhotoStack from "./templates/photo-stack";
import PictureInPicture from "./templates/picture-in-picture";
import PieChart from "./templates/pie-chart";
import PixelTransition from "./templates/pixel-transition";
import PolaroidFrame from "./templates/polaroid-frame";
import PoppingText from "./templates/popping-text";
import ProgressBars from "./templates/progress-bars";
import ProgressSteps from "./templates/progress-steps";
import PulsingText from "./templates/pulsing-text";
import PushTransition from "./templates/push-transition";
import QuoteCardTemplate from "./templates/quote-card";
import RotatingCarousel from "./templates/rotating-carousel";
import SlideText from "./templates/slide-text";
import SlideWipe from "./templates/slide-wipe";
import SoundWave from "./templates/sound-wave";
import SplitScreen from "./templates/split-screen";
import SpotlightReveal from "./templates/spotlight-reveal";
import Starfield from "./templates/starfield";
import StatCounter from "./templates/stat-counter";
import SubscribeReminder from "./templates/subscribe-reminder";
import TextHighlight from "./templates/text-highlight";
import TitleSplit from "./templates/title-split";
import TypewriterSubtitle from "./templates/typewriter-subtitle";
import VignettePulse from "./templates/vignette-pulse";
import WhipPan from "./templates/whip-pan";
import ZoomPulse from "./templates/zoom-pulse";
import ZoomThrough from "./templates/zoom-through";
import { KedarnathTC1 } from "./KedarnathTC1";
import { KedarnathTC2 } from "./KedarnathTC2";
import { KedarnathTC3 } from "./KedarnathTC3";
import { KedarnathTC4 } from "./KedarnathTC4";
import { KedarnathTC5 } from "./KedarnathTC5";
import { HarHarMahadev } from "./HarHarMahadev";
import { TeaserMontage } from "./TeaserMontage";
import { PaperRipCollage } from "./PaperRipCollage";
import { PaperRipReveal } from "./PaperRipReveal";
import { Composition, AbsoluteFill, Sequence, useCurrentFrame, interpolate, Easing, OffthreadVideo, staticFile } from "remotion";
import { DevaKathaLS1 } from "./DevaKathaLS1";
import { DevaKathaLS2 } from "./DevaKathaLS2";
import { DevaKathaLS3 } from "./DevaKathaLS3";
import { DevaKathaLS4 } from "./DevaKathaLS4";
import { DevaKathaLS5 } from "./DevaKathaLS5";
import { DevaKathaLS6 } from "./DevaKathaLS6";
import { DevaKathaLS7 } from "./DevaKathaLS7";
import { DevaKathaLS8 } from "./DevaKathaLS8";
import { DevaKathaLS9 } from "./DevaKathaLS9";
import { DevaKathaLS10 } from "./DevaKathaLS10";
import { DevaKathaShare } from "./DevaKathaShare";
import { RadhaPhraseTL, RadhaQuoteBMA, RadhaComment, RadhaAgeDekhiye, RadhaOverlaysFull } from "./RadhaOverlays";
import { KedarnathOverlaysFull } from "./KedarnathOverlays";
import { KedarnathPanchKedarOverlaysFull } from "./KedarnathPanchKedarOverlays";
import { MountKailashOverlaysFull } from "./MountKailashOverlays";
import { SomnathOverlaysFull } from "./SomnathOverlays";
import { DevshayaniOverlaysFull } from "./DevshayaniEkadashiOverlays";
import { KanwarYatraOverlaysFull } from "./KanwarYatraOverlays";
import { SawanShivratriOverlaysFull } from "./SawanShivratriOverlays";
import { NagPanchamiOverlaysFull } from "./NagPanchamiOverlays";
import { JanmashtamiOverlaysFull } from "./JanmashtamiOverlays";
import { RakshaBandhanOverlaysFull } from "./RakshaBandhanOverlays";
import { VaishnoDeviOverlaysFull } from "./VaishnoDeviOverlays";
import { OnamOverlaysFull } from "./OnamOverlays";
import { TeejOverlaysFull } from "./TeejOverlays";
import { NeelkanthOverlaysFull } from "./NeelkanthOverlays";
import { AmbajiOverlaysFull } from "./AmbajiOverlays";
import { VrindavanOverlaysFull } from "./VrindavanOverlays";
import { GaneshChaturthiOverlaysFull } from "./GaneshChaturthiOverlays";
import { KanwarCtaPreview } from "./KanwarCtaPreview";
import { HypeButton, HypePhone16x9 } from "./HypeButton";
import { NirjalaOverlaysFull } from "./NirjalaOverlays";
import { AmarnathOverlaysFull } from "./AmarnathOverlays";
import { MahakaleshwarOverlaysFull } from "./MahakaleshwarOverlays";
import { JagannathOverlaysFull } from "./JagannathOverlays";
import { RathYatraOverlaysFull } from "./RathYatraOverlays";
import { KamakhyaOverlaysFull, KamaAgeDekhiye } from "./KamakhyaOverlays";
import { KamakhyaPlayer } from "./KamakhyaPlayer";
import { JagannathLyrics } from "./JagannathLyrics";
import { ChakkaLyrics } from "./ChakkaLyrics";
import { OverlayManifest } from "./OverlayManifest";
import type { OverlayManifestData } from "./types";
import { compressManifest } from "./compressManifest";
import kedarnathRaw from "../public/kedarnath_manifest.json";
import { yamunotriManifest } from "./yamunotri_manifest";

// Style variant previews (A/B/C options for user selection)
import { StyleA_Preview } from "./StyleA_Preview";
import { StyleB_Preview } from "./StyleB_Preview";
import { StyleC_Preview } from "./StyleC_Preview";

// Bible Mysteries Decoder — overlay direction concepts (2026-07-18, on real style-test plate)
import { ConceptA_EvidenceBoard, ConceptB_ManuscriptMargin, ConceptC_ForensicLowerThird } from "./BibleDecoderOverlayConcepts";
// Bible Mysteries Decoder — FULL kit in the approved Concept C look (2026-07-18)
import {
  Showcase_RevealBeats, Showcase_InfoBeats, Showcase_SpecialBeats,
  Showcase_QuoteAndMyth, Showcase_MythBust, Showcase_Chapter, Showcase_EndCard,
} from "./BibleDecoderOverlayKit";
// Bible Mysteries Decoder — FINAL simplified 2-slot set, bright W01 plate (2026-07-18)
import { W01_OverlayTest_Citation, W01_OverlayTest_Reveal, W01_OverlayTest_Both } from "./BibleDecoderOverlayFinal";
import {
  BV_Demo1_Word, BV_Demo2_Citation, BV_Demo3_Place, BV_Demo4_Myth, BV_Demo5_Both,
} from "./BuriedVerseOverlayDemo";
import {
  BV_ConceptA_Specimen, BV_ConceptB_CaptionBand, BV_ConceptC_PinnedTag, BV_ConceptD_R1Fixed,
} from "./BuriedVerseConcepts";
import { BV_Logo1_Concept1, BV_Logo2_Diorama } from "./BuriedVerseLogoTest";
import {
  BuriedVerseE01Overlays,
  E01_FPS,
  E01_DURATION_FRAMES,
  E01_FPS_4K,
  E01_DURATION_FRAMES_4K,
} from "./BuriedVerseE01";
import {
  BuriedVerseE02RaptureOverlays,
  e02_rapture_FPS,
  e02_rapture_DURATION_FRAMES,
  e02_rapture_FPS_4K,
  e02_rapture_DURATION_FRAMES_4K,
} from "./BuriedVerseE02";
import {
  BuriedVerseE03ProdigalOverlays,
  e03_prodigal_FPS,
  e03_prodigal_DURATION_FRAMES,
  e03_prodigal_FPS_4K,
  e03_prodigal_DURATION_FRAMES_4K,
} from "./BuriedVerseE03";
import {
  BuriedVerseE04ShalomOverlays,
  e04_shalom_FPS,
  e04_shalom_DURATION_FRAMES,
  e04_shalom_FPS_4K,
  e04_shalom_DURATION_FRAMES_4K,
} from "./BuriedVerseE04";
import {
  BuriedVerseE05HellOverlays,
  e05_hell_FPS,
  e05_hell_DURATION_FRAMES,
  e05_hell_FPS_4K,
  e05_hell_DURATION_FRAMES_4K,
} from "./BuriedVerseE05";
import {
  BvCtaA_Subscribe, BvCtaA_Comment,
  BvCtaB_Subscribe, BvCtaB_Comment,
  BvCtaC_Subscribe, BvCtaC_Comment,
} from "./BuriedVerseCtaDemo";

// Preview compositions — one per overlay type with sample data
import { PersonTag } from "./PersonTag";
import { LocationTag } from "./LocationTag";
import { YearStamp } from "./YearStamp";
import { ScriptureRef } from "./ScriptureRef";
import { ScriptureRefB } from "./ScriptureRefB";
import { ScriptureRefC } from "./ScriptureRefC";
import { QuoteCard } from "./QuoteCard";
import { QuoteCardA } from "./QuoteCardA";
import { InfoBox } from "./InfoBox";
import { InfoBoxA } from "./InfoBoxA";
import { InfoBoxB } from "./InfoBoxB";
import { InfoBoxC } from "./InfoBoxC";
import { StatCard } from "./StatCard";
import { LogoWatermark } from "./LogoWatermark";
import { KedarnathEndCard } from "./KedarnathEndCard";
import { ShivlingCTA } from "./ShivlingCTA";
import { HarHarMahadevCTA } from "./HarHarMahadevCTA";
import { DevotionalReelOverlay } from "./DevotionalReelOverlay";
import { MantraCardBadrinath1 } from "./MantraCardBadrinath1";
import { JaiSomnathCTA } from "./JaiSomnathCTA";
import { HarHarGangeCTA } from "./HarHarGangeCTA";
import { ReelTitleStamp } from "./ReelTitleStamp";
import { WatchFullCTA } from "./WatchFullCTA";
import { CreatorCutCaption } from "./CreatorCutCaption";
import { ReelRollerCaption } from "./ReelRollerCaption";
import { ReelYouTubeCTA } from "./ReelYouTubeCTA";
import { ReelCTA1 } from "./ReelCTA1";
import { ReelCTA2 } from "./ReelCTA2";
import { ReelCTA3 } from "./ReelCTA3";
import { ReelCTA4 } from "./ReelCTA4";
import { ReelLS1 } from "./ReelLS1";
import { ReelLS2 } from "./ReelLS2";
import { ReelLS3 } from "./ReelLS3";
import { ReelLS4 } from "./ReelLS4";
import { ReelTextOverlay } from "./ReelTextOverlay";
import { ReelDualCTA } from "./ReelDualCTA";
import { ReelDualTextBox } from "./ReelDualTextBox";
import { ChocolatePreview } from "./ChocolatePreview";
import { ChocolateFullPreview } from "./ChocolateFullPreview";
import { TrimbakeshwarOverlays, TrimbakeshwarOpenerTitle, PART_A as TRIMBAK_A, PART_B as TRIMBAK_B } from "./TrimbakeshwarOverlays";
import { KrishnaOverlays, PART_A as KRISHNA_A, PART_B as KRISHNA_B } from "./KrishnaOverlays";
import { CocaColaFullPreview } from "./CocaColaFullPreview";
import { MoneyFullPreview } from "./MoneyFullPreview";
import { LaysFullPreview } from "./LaysFullPreview";
import { UraniumSeg1 } from "./UraniumSeg1";
import { UraniumSeg23 } from "./UraniumSeg23";
import { UraniumFull } from "./UraniumFull";
import { SCTagsPreview, SCTwoNamesPreview, SC_W, SC_H, SC_FPS } from "./SanatanCinematicsTags";
import { SanatanGroupOverlay, SCGroupDemo, SC_GROUP_DEMO, scGroupMetadata } from "./SanatanGroupOverlay";
import { EpisodeComp as Ep_gotra_ep01_v21 } from "./gotra_ep01_v21/EpisodeComp";
import { EpisodeComp as Ep_pitru_paksha } from "./pitru_paksha/EpisodeComp";
import { EpisodeComp as Ep_pind_daan } from "./pind_daan/EpisodeComp";
import { EpisodeComp as Ep_kanya_pujan } from "./kanya_pujan/EpisodeComp";

const W = 1280, H = 704, FPS = 24;
const RW = 720, RH = 1280, RFPS = 16;

const PREVIEW_BG = "linear-gradient(135deg, #2a4a3a 0%, #1a2a3a 100%)";

const YearStampHindiPreview: React.FC = () => (
  <AbsoluteFill style={{ background: PREVIEW_BG }}>
    <OverlayManifest manifest={{ production_id: "preview", temple: "Preview", temple_hindi: "पूर्वावलोकन", total_duration_ms: 5000,
      overlays: [{ type: "year_stamp", start_ms: 0, end_ms: 5000, data: { display: "12वीं सदी", display_latin: "12th Century CE", context: "Raja Anek Mall establishes Trishuls in the region" } }] }} />
  </AbsoluteFill>
);

const YearStampLatinPreview: React.FC = () => (
  <AbsoluteFill style={{ background: PREVIEW_BG }}>
    <OverlayManifest manifest={{ production_id: "preview", temple: "Preview", temple_hindi: "पूर्वावलोकन", total_duration_ms: 5000,
      overlays: [{ type: "year_stamp", start_ms: 0, end_ms: 5000, data: { display: "1910 CE", display_latin: "1910 CE", context: "H.G. Walton publishes British Garhwal Gazetteer" } }] }} />
  </AbsoluteFill>
);

const TwoYearStampsPreview: React.FC = () => (
  <AbsoluteFill style={{ background: PREVIEW_BG }}>
    <OverlayManifest manifest={{ production_id: "preview", temple: "Preview", temple_hindi: "पूर्वावलोकन", total_duration_ms: 6000,
      overlays: [
        { type: "year_stamp", start_ms: 0,    end_ms: 5000, data: { display: "12वीं सदी", display_latin: "12th Century CE" } },
        { type: "year_stamp", start_ms: 1000, end_ms: 6000, data: { display: "1910 CE",   display_latin: "1910 CE" } },
      ] }} />
  </AbsoluteFill>
);

const PersonTagPreview: React.FC = () => (
  <AbsoluteFill style={{ background: "#000" }}>
    <PersonTag data={{ name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages performing penance at Badri Ashram" }} durationInFrames={72} />
  </AbsoluteFill>
);

const MULTI_TAG_CONFIGS = [
  { name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages in deep meditation at Badri Ashram" },
  { name: "Bhairava", name_hindi: "भैरव", role: "Guardian of Kedarnath Region" },
  { name: "Shiva", name_hindi: "शिव", role: "The Destroyer and Transformer" },
  { name: "Parvati", name_hindi: "पार्वती", role: "Goddess of Love and Devotion" },
  { name: "Vishnu", name_hindi: "विष्णु", role: "The Preserver of the Universe" },
];
const TAG_DURATION = 72;
const TAG_STAGGER = 24;
const TAG_FADE = 12;
const TAG_BASE_BOTTOM = 30;
const TAG_SLOT_H = 48;

const TwoTagsPreview: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill style={{ background: "#000" }}>
      {MULTI_TAG_CONFIGS.map((data, i) => {
        const startFrame = i * TAG_STAGGER;
        let slot = i;
        for (let j = 0; j < i; j++) {
          const jFadeStart = j * TAG_STAGGER + TAG_DURATION - TAG_FADE;
          const jFadeEnd = j * TAG_STAGGER + TAG_DURATION;
          slot -= interpolate(frame, [jFadeStart, jFadeEnd], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
        }
        return (
          <PersonTag
            key={i}
            data={data}
            durationInFrames={TAG_DURATION}
            startFrame={startFrame}
            bottom={TAG_BASE_BOTTOM + slot * TAG_SLOT_H}
          />
        );
      })}
    </AbsoluteFill>
  );
};

const SIX_TAG_END = 192;
const SIX_TAG_CONFIGS = [
  { name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages in deep meditation at Badri Ashram" },
  { name: "Bhairava",          name_hindi: "भैरव",           role: "Guardian of Kedarnath Region" },
  { name: "Shiva",             name_hindi: "शिव",            role: "The Destroyer and Transformer" },
  { name: "Parvati",           name_hindi: "पार्वती",        role: "Goddess of Love and Devotion" },
  { name: "Vishnu",            name_hindi: "विष्णु",         role: "The Preserver of the Universe" },
  { name: "Brahma",            name_hindi: "ब्रह्मा",        role: "The Creator of the Universe" },
];

const SixTagsPreview: React.FC = () => (
  <AbsoluteFill style={{ background: "#000" }}>
    {SIX_TAG_CONFIGS.map((data, i) => {
      const startFrame = i * 24;
      return (
        <PersonTag
          key={i}
          data={data}
          durationInFrames={SIX_TAG_END - startFrame}
          startFrame={startFrame}
          bottom={30 + i * 40}
          fontScale={0.8}
        />
      );
    })}
  </AbsoluteFill>
);

const SIX_LOC_TAG_CONFIGS = [
  { name: "Kedarnath",       name_hindi: "केदारनाथ",      detail: "Seat of Shiva — 3,583m" },
  { name: "Badrinath",       name_hindi: "बद्रीनाथ",      detail: "Abode of Vishnu — 3,133m" },
  { name: "Gangotri",        name_hindi: "गंगोत्री",       detail: "Source of the Ganges — 3,100m" },
  { name: "Yamunotri",       name_hindi: "यमुनोत्री",      detail: "Source of the Yamuna — 3,293m" },
  { name: "Madhyamaheshwar", name_hindi: "मध्यमहेश्वर",   detail: "Shiva's Navel — 3,497m" },
  { name: "Tungnath",        name_hindi: "तुंगनाथ",        detail: "Highest Shiva Temple — 3,680m" },
];

const SixLocationTagsPreview: React.FC = () => (
  <AbsoluteFill style={{ background: "#000" }}>
    {SIX_LOC_TAG_CONFIGS.map((data, i) => {
      const startFrame = i * 24;
      return (
        <LocationTag
          key={i}
          data={data}
          durationInFrames={SIX_TAG_END - startFrame}
          startFrame={startFrame}
          bottom={30 + i * 40}
          fontScale={0.8}
        />
      );
    })}
  </AbsoluteFill>
);

const REPLACE_FINAL_FADE_END = 156;
const REPLACE_SLOT_BOTTOM = [30, 78, 126];
const REPLACE_CONFIG = [
  { data: { name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages in deep meditation at Badri Ashram" }, slot: 0, startFrame: 0,  endFrame: 72 },
  { data: { name: "Bhairava",          name_hindi: "भैरव",           role: "Guardian of Kedarnath Region" },             slot: 1, startFrame: 24, endFrame: 96 },
  { data: { name: "Shiva",             name_hindi: "शिव",            role: "The Destroyer and Transformer" },             slot: 2, startFrame: 48, endFrame: REPLACE_FINAL_FADE_END },
  { data: { name: "Parvati",           name_hindi: "पार्वती",        role: "Goddess of Love and Devotion" },              slot: 0, startFrame: 72, endFrame: REPLACE_FINAL_FADE_END },
  { data: { name: "Vishnu",            name_hindi: "विष्णु",         role: "The Preserver of the Universe" },             slot: 1, startFrame: 96, endFrame: REPLACE_FINAL_FADE_END },
];

const ReplaceTagsPreview: React.FC = () => (
  <AbsoluteFill style={{ background: "#000" }}>
    {REPLACE_CONFIG.map((cfg, i) => (
      <PersonTag
        key={i}
        data={cfg.data}
        durationInFrames={cfg.endFrame - cfg.startFrame}
        startFrame={cfg.startFrame}
        bottom={REPLACE_SLOT_BOTTOM[cfg.slot]}
      />
    ))}
  </AbsoluteFill>
);

const QUOTE_SHIFT = 60;
const QS_TOTAL = 336;
const QS_QUOTE_IN = 72;
const QS_QUOTE_OUT = 240;
const QS_SIX_END = 300;

const QuoteShiftPreview: React.FC = () => {
  const frame = useCurrentFrame();

  const shiftIn = interpolate(frame,
    [QS_QUOTE_IN, QS_QUOTE_IN + Math.round(1.0 * FPS)],
    [0, QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) }
  );
  const shiftOut = interpolate(frame,
    [QS_QUOTE_OUT - Math.round(1.0 * FPS), QS_QUOTE_OUT],
    [0, -QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.7, 0, 0.84, 0) }
  );
  const bottomOffset = shiftIn + shiftOut;

  return (
    <AbsoluteFill style={{ background: "#000" }}>
      {SIX_TAG_CONFIGS.map((data, i) => (
        <PersonTag
          key={i}
          data={data}
          durationInFrames={QS_SIX_END - i * 24}
          startFrame={i * 24}
          bottom={30 + i * 40 + bottomOffset}
          fontScale={0.8}
        />
      ))}
      {SIX_LOC_TAG_CONFIGS.map((data, i) => (
        <LocationTag
          key={i}
          data={data}
          durationInFrames={QS_SIX_END - i * 24}
          startFrame={i * 24}
          bottom={30 + i * 40 + bottomOffset}
          fontScale={0.8}
        />
      ))}
      <Sequence from={QS_QUOTE_IN}>
        <QuoteCardA
          data={{ text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }}
          durationInFrames={QS_QUOTE_OUT - QS_QUOTE_IN}
        />
      </Sequence>
    </AbsoluteFill>
  );
};

const YIP_TOTAL = 336;
const YIP_QUOTE_IN = 72;
const YIP_QUOTE_OUT = 240;

const YearInfoOverlapPreview: React.FC = () => {
  const frame = useCurrentFrame();

  const shiftIn = interpolate(frame,
    [YIP_QUOTE_IN, YIP_QUOTE_IN + Math.round(1.0 * FPS)],
    [0, QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) }
  );
  const shiftOut = interpolate(frame,
    [YIP_QUOTE_OUT - Math.round(1.0 * FPS), YIP_QUOTE_OUT],
    [0, -QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.7, 0, 0.84, 0) }
  );
  const bottomOffset = shiftIn + shiftOut;

  return (
    <AbsoluteFill style={{ background: PREVIEW_BG }}>
      <YearStamp
        data={{ display: "12वीं सदी", display_latin: "12th Century CE", context: "Raja Anek Mall establishes Trishuls in the region" }}
        durationInFrames={YIP_TOTAL}
      />
      <ScriptureRef
        data={{ scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }}
        durationInFrames={YIP_TOTAL}
      />
      <StatCard
        data={{ stats: [
          { label: "Altitude", value: "3,583m", value_secondary: "11,755 ft" },
          { label: "Established", value: "8th Century" },
          { label: "Pilgrims / Year", value: "~10 Lakh" },
        ] }}
        durationInFrames={YIP_TOTAL}
        top={171}
      />
      <InfoBoxC
        data={{ label: "BHAIRON JHAP", label_hindi: "भैरों झाप", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }}
        durationInFrames={YIP_TOTAL}
      />
      {SIX_TAG_CONFIGS.map((data, i) => (
        <PersonTag key={i} data={data} durationInFrames={QS_SIX_END - i * 24} startFrame={i * 24} bottom={30 + i * 40 + bottomOffset} fontScale={0.8} />
      ))}
      {SIX_LOC_TAG_CONFIGS.map((data, i) => (
        <LocationTag key={i} data={data} durationInFrames={QS_SIX_END - i * 24} startFrame={i * 24} bottom={30 + i * 40 + bottomOffset} fontScale={0.8} />
      ))}
      <Sequence from={Math.round(YIP_TOTAL * 0.6)}>
        <DevaKathaLS2 align="center" scale={1} bottomOffset={80} />
      </Sequence>

      <Sequence from={YIP_QUOTE_IN}>
        <QuoteCardA
          data={{ text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }}
          durationInFrames={YIP_QUOTE_OUT - YIP_QUOTE_IN}
        />
      </Sequence>
    </AbsoluteFill>
  );
};

const SCENARIO_TOTAL = 864;
const SC_QUOTE_IN = 336;
const SC_QUOTE_OUT = 456;

const SC_G1_END = 264;
const SC_G2_END = 432;

const SC_G1_TAGS: Array<{ type: "person" | "location"; data: any; start: number }> = [
  { type: "person",   data: { name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages in deep meditation at Badri Ashram" },   start: 0 },
  { type: "location", data: { name: "Kedarnath",   name_hindi: "केदारनाथ",   detail: "Seat of Shiva — 3,583m" },  start: 48 },
  { type: "person",   data: { name: "Bhairava",    name_hindi: "भैरव",       role: "Guardian of Kedarnath Region" },                        start: 120 },
  { type: "location", data: { name: "Badrinath",   name_hindi: "बद्रीनाथ",  detail: "Abode of Vishnu — 3,133m" }, start: 144 },
];
const SC_G2_TAGS: Array<{ type: "person" | "location"; data: any; start: number }> = [
  { type: "person",   data: { name: "Shiva", name_hindi: "शिव", role: "The Destroyer and Transformer" }, start: 288 },
  { type: "location", data: { name: "Gangotri", name_hindi: "गंगोत्री", detail: "Source of the Ganges — 3,100m" }, start: 312 },
];

const ScenarioPreview: React.FC = () => {
  const frame = useCurrentFrame();

  const scShiftIn = interpolate(frame,
    [SC_QUOTE_IN, SC_QUOTE_IN + Math.round(1.0 * FPS)],
    [0, QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) }
  );
  const scShiftOut = interpolate(frame,
    [SC_QUOTE_OUT - Math.round(1.0 * FPS), SC_QUOTE_OUT],
    [0, -QUOTE_SHIFT],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.7, 0, 0.84, 0) }
  );
  const g2BottomOffset = scShiftIn + scShiftOut;

  return (
    <AbsoluteFill style={{ background: PREVIEW_BG }}>
      <LogoWatermark />

      {(() => {
        let pi = 0, li = 0;
        return SC_G1_TAGS.map((t, i) => {
          if (t.type === "person") {
            const slot = pi++;
            return <PersonTag key={i} data={t.data} durationInFrames={SC_G1_END - t.start} startFrame={t.start} bottom={30 + slot * 40} fontScale={0.8} />;
          } else {
            const slot = li++;
            return <LocationTag key={i} data={t.data} durationInFrames={SC_G1_END - t.start} startFrame={t.start} bottom={30 + slot * 40} fontScale={0.8} />;
          }
        });
      })()}

      <Sequence from={96}><YearStamp data={{ display: "12वीं सदी", display_latin: "12th Century CE", context: "Raja Anek Mall establishes Trishuls in the region" }} durationInFrames={120} /></Sequence>
      <InfoBoxC data={{ label: "BHAIRON JHAP", label_hindi: "भैरों झाप", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }} durationInFrames={120} startFrame={96} top={117} />
      <Sequence from={192}><ScriptureRef data={{ scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }} durationInFrames={120} /></Sequence>

      {(() => {
        let pi = 0, li = 0;
        return SC_G2_TAGS.map((t, i) => {
          if (t.type === "person") {
            const slot = pi++;
            return <PersonTag key={i} data={t.data} durationInFrames={SC_G2_END - t.start} startFrame={t.start} bottom={30 + slot * 40 + g2BottomOffset} fontScale={0.8} />;
          } else {
            const slot = li++;
            return <LocationTag key={i} data={t.data} durationInFrames={SC_G2_END - t.start} startFrame={t.start} bottom={30 + slot * 40 + g2BottomOffset} fontScale={0.8} />;
          }
        });
      })()}

      <Sequence from={SC_QUOTE_IN}><QuoteCardA data={{ text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }} durationInFrames={SC_QUOTE_OUT - SC_QUOTE_IN} /></Sequence>

      <Sequence from={480}><YearStamp data={{ display: "1910 CE", context: "H.G. Walton publishes British Garhwal Gazetteer" }} durationInFrames={120} /></Sequence>
      <Sequence from={480}><StatCard data={{ stats: [{ label: "Altitude", value: "3,583m", value_secondary: "11,755 ft" }, { label: "Established", value: "8th Century" }, { label: "Pilgrims / Year", value: "~10 Lakh" }] }} durationInFrames={120} top={171} /></Sequence>

      <Sequence from={600}><DevaKathaLS2 align="center" scale={1} bottomOffset={80} /></Sequence>

      {(() => {
        const infoBoxTop = interpolate(frame,
          [744, 744 + Math.round(1.5 * FPS)],
          [25, 117],
          { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.4, 0, 0.2, 1) }
        );
        return (
          <>
            <InfoBoxC data={{ label: "PANCHKEDAR", label_hindi: "पंचकेदार", text: "Five sacred shrines of Lord Shiva in the Garhwal Himalayas.", text_hindi: "गढ़वाल हिमालय में भगवान शिव के पाँच पवित्र मंदिर।" }} durationInFrames={120} startFrame={696} top={infoBoxTop} />
            <Sequence from={744}><YearStamp data={{ display: "8वीं सदी", display_latin: "8th Century CE", context: "Adi Shankaracharya establishes the Panch Kedar shrines" }} durationInFrames={120} /></Sequence>
</>
        );
      })()}

    </AbsoluteFill>
  );
};

const defaultManifest: OverlayManifestData = {
  production_id: "00000000-0000-0000-0000-000000000000",
  temple: "Preview",
  temple_hindi: "पूर्वावलोकन",
  total_duration_ms: 60000,
  overlays: [],
};

const lsProps = { durationInFrames: 96, fps: 24, width: 1280, height: 704 };

const previewManifest: OverlayManifestData = {
  production_id: "preview-0000-0000-0000-000000000000",
  temple: "Kedarnath",
  temple_hindi: "केदारनाथ",
  total_duration_ms: 8000,
  overlays: [
    { type: "person_tag",    start_ms: 500,  end_ms: 5000, data: { name: "Nara and Narayana", name_hindi: "नर और नारायण", role: "Sages performing penance at Badri Ashram", period: "Mythological Era" } },
    { type: "location_tag",  start_ms: 500,  end_ms: 5000, data: { name: "Madhyamaheshwar", name_hindi: "मध्यमहेश्वर", detail: "Manifestation of Shiva's Navel (Nabhi)" } },
    { type: "year_stamp",    start_ms: 500,  end_ms: 5000, data: { display: "12वीं सदी", display_latin: "12th Century CE", context: "Raja Anek Mall establishes Trishuls in the region" } },
    { type: "scripture_ref", start_ms: 500,  end_ms: 5000, data: { scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" } },
    { type: "quote_card",    start_ms: 5500, end_ms: 8000, data: { text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" } },
    { type: "info_box",      start_ms: 5500, end_ms: 8000, data: { label: "BHAIRON JHAP", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha (liberation).", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" } },
  ],
};

export const RemotionRoot: React.FC = () => {
  return (
    <>
      {/* Like/Subscribe animations */}

      <Composition id="deva-katha-like-subscribe-1"  component={DevaKathaLS1}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-2"  component={DevaKathaLS2}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-3"  component={DevaKathaLS3}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-4"  component={DevaKathaLS4}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-5"  component={DevaKathaLS5}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-6"  component={DevaKathaLS6}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-7"  component={DevaKathaLS7}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-8"  component={DevaKathaLS8}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-9"  component={DevaKathaLS9}  {...lsProps} />
      <Composition id="deva-katha-like-subscribe-10" component={DevaKathaLS10} {...lsProps} />
      <Composition id="deva-katha-share" component={DevaKathaShare} {...lsProps} />
      <Composition id="radha-phrase-tl" component={RadhaPhraseTL} durationInFrames={48} fps={16} width={1280} height={704} />
      <Composition id="radha-quote-bma" component={RadhaQuoteBMA} durationInFrames={48} fps={16} width={1280} height={704} />
      <Composition id="radha-comment" component={RadhaComment} durationInFrames={56} fps={16} width={1280} height={704} />
      <Composition id="radha-age-dekhiye" component={RadhaAgeDekhiye} durationInFrames={240} fps={16} width={1280} height={704} />
      <Composition id="radha-overlays-full" component={RadhaOverlaysFull} durationInFrames={6375} fps={16} width={1280} height={704} />
      <Composition id="kedarnath-overlays" component={KedarnathOverlaysFull} durationInFrames={9860} fps={16} width={1280} height={704} />
      <Composition id="kedarnath-panchkedar-overlays" component={KedarnathPanchKedarOverlaysFull} durationInFrames={19616} fps={16} width={1280} height={704} />
      <Composition id="kedarnath-panchkedar-overlays-4k" component={KedarnathPanchKedarOverlaysFull} durationInFrames={29570} fps={24} width={1280} height={704} />
      <Composition id="mount-kailash-overlays" component={MountKailashOverlaysFull} durationInFrames={21264} fps={16} width={1280} height={704} />
      {/* Somnath e0232a65 — 4K comp @ fps=24 (Topaz base is 24fps; factory_4k_full renders at scale=3
          → 3840×2112). narration 1314.26s → 1316s of frames for cushion. */}
      <Composition id="somnath-overlays-4k" component={SomnathOverlaysFull} durationInFrames={31584} fps={24} width={1280} height={704} />
      {/* Devshayani Ekadashi 91225dd9 — 4K comp @ fps=24 (factory_4k_full renders at scale=3 → 3840×2112).
          narration 1315.05s → 31584 frames (~1316s) cushion. */}
      <Composition id="devshayani-overlays-4k" component={DevshayaniOverlaysFull} durationInFrames={31584} fps={24} width={1280} height={704} />
      {/* Kanwar Yatra 4f64cf48 — 4K comp @ fps=24 (factory_4k_full renders at scale=3 → 3840×2112).
          narration 1433.94s → 34464 frames (1436s) cushion. */}
      <Composition id="kanwar-yatra-overlays-4k" component={KanwarYatraOverlaysFull} durationInFrames={34464} fps={24} width={1280} height={704} />
      {/* Sawan Shivratri e8c65b92 — 4K comp @ fps=24 (factory_4k_full renders at scale=3 → 3840×2112).
          narration 1357.37s → 32640 frames (1360s) cushion. 62 phrase cards + 3 shared Hype CTAs. */}
      <Composition id="sawan-shivratri-overlays-4k" component={SawanShivratriOverlaysFull} durationInFrames={32640} fps={24} width={1280} height={704} />
      {/* Nag Panchami 67fc8a87 — 4K comp @ fps=24 (factory_4k_full renders at scale=3 → 3840×2112).
          narration 1604.25s → 38568 frames (1607s) cushion. 75 phrase cards + 3 shared Hype CTAs. */}
      <Composition id="nag-panchami-overlays-4k" component={NagPanchamiOverlaysFull} durationInFrames={38568} fps={24} width={1280} height={704} />
      <Composition id="janmashtami-overlays-4k" component={JanmashtamiOverlaysFull} durationInFrames={47520} fps={24} width={1280} height={704} />
      <Composition id="raksha-bandhan-overlays-4k" component={RakshaBandhanOverlaysFull} durationInFrames={36384} fps={24} width={1280} height={704} />
      <Composition id="vaishno-devi-overlays-4k" component={VaishnoDeviOverlaysFull} durationInFrames={29736} fps={24} width={1280} height={720} />
      <Composition id="onam-overlays-4k" component={OnamOverlaysFull} durationInFrames={39744} fps={24} width={1280} height={704} />
      <Composition id="teej-overlays-4k" component={TeejOverlaysFull} durationInFrames={31656} fps={24} width={1280} height={704} />
      <Composition id="neelkanth-overlays-4k" component={NeelkanthOverlaysFull} durationInFrames={29450} fps={24} width={1280} height={704} />
      <Composition id="ambaji-overlays-4k" component={AmbajiOverlaysFull} durationInFrames={30360} fps={24} width={1280} height={720} />
      <Composition id="vrindavan-overlays-4k" component={VrindavanOverlaysFull} durationInFrames={46320} fps={24} width={1280} height={720} />
      {/* Ganesh Chaturthi f7590e26 — MINIMAX-H3 lane (17n+5 lattice, max 192f, no negative
          prompt). 1280x720 @ 24fps is MANDATORY here: assemble writes the H3 lane at
          1344x756@24, and factory_4k_full renders this comp at scale=3 -> 3840x2160.
          Runtime 1463.92s -> 35134 frames; 35376 leaves ~10s of cushion for the freeze tail. */}
      <Composition id="ganesh-chaturthi-overlays-4k" component={GaneshChaturthiOverlaysFull} durationInFrames={35376} fps={24} width={1280} height={720} />
      {/* ⭐ Lalbaugcha Raja (ganesh_chaturthi_mumbai 3340a006) — the LIVE overlay set.
          [2026-08-15] This <Composition> was pasted INSIDE another preview component's JSX
          (~line 652) instead of RemotionRoot, so it never registered and every cluster died
          with "Could not find composition with ID lalbaug-overlays-4k". Moved here. */}
      <Composition id="lalbaug-overlays-4k" component={LalbaugchaRajaOverlays} durationInFrames={33840} fps={24} width={1280} height={720} />
      {/* ⭐ Navratri Days 1-3 (navratri_days_1_3 b4cc7445) — MiniMax-H3 lane, base 1344x756@24.
          61 phrase cards + 3 DevaKathaHypeCta phones. duration 1166.63s -> 28000 frames + cushion.
          ⛔ This MUST live inside RemotionRoot — see the Lalbaug note above. */}
      <Composition id="navratri-days-1-3-overlays-4k" component={NavratriDays13Overlays} durationInFrames={28030} fps={24} width={1280} height={720} />
      {/* ⭐ Navratri Days 4-6 (navratri_days_4_6 a36164df) — MiniMax-H3 lane, base 1344x756@24.
          63 phrase cards + 2 DevaKathaHypeCta phones. duration 1149.04s -> 27577 frames + cushion.
          ⛔ This MUST live inside RemotionRoot — see the Lalbaug note above. */}
      <Composition id="navratri-days-4-6-overlays-4k" component={NavratriDays46Overlays} durationInFrames={27610} fps={24} width={1280} height={720} />
      {/* ⭐ Navratri Days 7-9 (navratri_days_7_9 a0d8b74c) — MiniMax-H3 lane, base 1344x756@24.
          61 phrase cards + 2 DevaKathaHypeCta phones. duration 1085.91s -> 26062 frames + cushion.
          ⛔ This MUST live inside RemotionRoot — see the Lalbaug note above. */}
      <Composition id="navratri-days-7-9-overlays-4k" component={NavratriDays79Overlays} durationInFrames={26095} fps={24} width={1280} height={720} />
      <Composition id="neem-karoli-baba-overlays-4k" component={NeemKaroliBabaOverlays} durationInFrames={36840} fps={30} width={1280} height={720} />
      <Composition id="khade-hanuman-ujjain-overlays-4k" component={KhadeHanumanUjjainOverlays} durationInFrames={37230} fps={30} width={1280} height={720} />
      <Composition id="badrinath-overlays-4k" component={BadrinathOverlays} durationInFrames={36264} fps={24} width={1280} height={720} />
      <Composition id="ukhimath-overlays-4k" component={UkhimathOverlays} durationInFrames={39384} fps={24} width={1280} height={720} />
      <Composition id="karva-chauth-overlays-4k" component={KarvaChauthOverlays} durationInFrames={28584} fps={24} width={1280} height={720} />
      <Composition id="chaudah-varsh-overlays-4k" component={ChaudahVarshOverlays} durationInFrames={66660} fps={30} width={1280} height={720} />
      <Composition id="navratri-katha-overlays-4k" component={NavratriKathaOverlays} durationInFrames={38945} fps={24} width={1280} height={720} />
      {/* Kanwar outro-CTA LOCAL PREVIEW — 20s (1414→1434s) of the real 720p with the Hype
          phone on top. VPS-rendered for judgement only; not part of the pipeline. */}
      <Composition id="kanwar-cta-preview" component={KanwarCtaPreview} durationInFrames={480} fps={24} width={1280} height={704}
                   defaultProps={{ startAt: 1414, base: "kanwar_cta_base.mp4" }} />
      {/* the two mid-roll CTA beats, same Hype phone */}
      <Composition id="kanwar-cta1-preview" component={KanwarCtaPreview} durationInFrames={336} fps={24} width={1280} height={704}
                   defaultProps={{ startAt: 186.5, base: "kanwar_cta1_base.mp4" }} />
      <Composition id="kanwar-cta2-preview" component={KanwarCtaPreview} durationInFrames={336} fps={24} width={1280} height={704}
                   defaultProps={{ startAt: 1118.5, base: "kanwar_cta2_base.mp4" }} />
      {/* YouTube "Hype" button UI mimic — STANDALONE PREVIEW ONLY (researched 2026-07-15).
          Open "hype-button" in Remotion Studio to see the resting chip → tap → burst →
          "Hyped" → leaderboard badge loop. NOT wired into any documentary overlay yet. */}
      <Composition id="hype-button" component={HypeButton} durationInFrames={225} fps={30} width={720} height={1280} />
      {/* 16:9 as it ships — phone popped over the real doc at the mid-roll CTA.
          1280×704 @ 16fps = the docs' native frame (NOT 1280×720/30); matches the base cut. */}
      <Composition id="hype-phone-16x9" component={HypePhone16x9} durationInFrames={256} fps={16} width={1280} height={704} />
      <Composition id="nirjala-overlays" component={NirjalaOverlaysFull} durationInFrames={9000} fps={16} width={1280} height={704} />
      <Composition id="nirjala-overlays-4k" component={NirjalaOverlaysFull} durationInFrames={13503} fps={24} width={1280} height={704} />
      <Composition id="kamakhya-overlays" component={KamakhyaOverlaysFull} durationInFrames={19220} fps={16} width={1280} height={704} />
      <Composition id="amarnath-overlays-4k" component={AmarnathOverlaysFull} durationInFrames={33168} fps={24} width={1280} height={704} />
      <Composition id="mahakaleshwar-overlays-4k" component={MahakaleshwarOverlaysFull} durationInFrames={32568} fps={24} width={1280} height={704} />
      <Composition id="jagannath-overlays-4k" component={JagannathOverlaysFull} durationInFrames={46872} fps={24} width={1280} height={704} />
      <Composition id="rath-yatra-overlays-4k" component={RathYatraOverlaysFull} durationInFrames={32328} fps={24} width={1280} height={704} />
      <Composition id="kama-age-dekhiye" component={KamaAgeDekhiye} durationInFrames={1216} fps={16} width={1280} height={704} />
      <Composition id="kamakhya-player" component={KamakhyaPlayer} durationInFrames={5828} fps={30} width={1280} height={704} />
      <Composition id="jagannath-lyrics" component={JagannathLyrics} durationInFrames={4347} fps={16} width={1280} height={704} />
      <Composition id="jagannath-lyrics-4k" component={JagannathLyrics} durationInFrames={6518} fps={24} width={1280} height={704} />
      <Composition id="chakka-lyrics" component={ChakkaLyrics} durationInFrames={4271} fps={16} width={1280} height={704} />
      <Composition id="chakka-lyrics-4k" component={ChakkaLyrics} durationInFrames={6398} fps={24} width={1280} height={704} />

      {/* Title cards */}
      <Composition id="kedarnath-title-card-1" component={KedarnathTC1} durationInFrames={120} fps={24} width={1280} height={704} />
      <Composition id="kedarnath-title-card-2" component={KedarnathTC2} durationInFrames={120} fps={24} width={1280} height={704} />
      <Composition id="kedarnath-title-card-3" component={KedarnathTC3} durationInFrames={120} fps={24} width={1280} height={704} />
      <Composition id="kedarnath-title-card-4" component={KedarnathTC4} durationInFrames={120} fps={24} width={1280} height={704} />
      <Composition id="kedarnath-title-card-5" component={KedarnathTC5} durationInFrames={120} fps={24} width={1280} height={704} />
      <Composition id="har-har-mahadev" component={HarHarMahadev} durationInFrames={168} fps={24} width={1280} height={704} />

      {/* Yamunotri teaser cold-open prototype — 22 anchors, 10s @ 24fps */}
      <Composition id="yamunotri-teaser" component={TeaserMontage} durationInFrames={360} fps={24} width={1920} height={1080} />

      {/* Paper-rip moodboard intro — 34 anchors collaged with torn-paper masks, 17s @ 30fps */}
      <Composition id="paper-rip-collage" component={PaperRipCollage} durationInFrames={510} fps={30} width={1920} height={1080} />

      {/* Paper-rip sequential reveal — 30 anchors, each tears apart revealing next, 17s @ 16fps @ 720p */}
      <Composition id="paper-rip-reveal" component={PaperRipReveal} durationInFrames={272} fps={16} width={1280} height={720} />

      {/* Main render composition */}
      <Composition
        id="OverlayManifest"
        component={OverlayManifest}
        fps={FPS}
        width={W}
        height={H}
        defaultProps={{ manifest: defaultManifest }}
        calculateMetadata={async ({ props }: { props: { manifest: OverlayManifestData } }) => ({
          durationInFrames: Math.max(Math.round((props.manifest.total_duration_ms / 1000) * FPS), FPS),
        })}
      />

      {/* Yamunotri — 24fps to match the 24fps Topaz 4K base (Modal render).
          OverlayManifest is fully time-based, so visuals are identical to the
          16fps preview — just smoother and frame-aligned to the 4K. */}
      <Composition
        id="yamunotri-full"
        component={OverlayManifest}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={Math.ceil((yamunotriManifest.total_duration_ms / 1000) * 24)}
        defaultProps={{ manifest: yamunotriManifest }}
      />

      {/* Style variant comparisons */}
      <Composition id="style-a-lower-third" component={StyleA_Preview} fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="style-b-borderless"  component={StyleB_Preview} fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="style-c-warm-amber"  component={StyleC_Preview} fps={FPS} width={W} height={H} durationInFrames={72} />

      {/* Bible Mysteries Decoder overlay concepts — on real kadosh closeup plate, for Yash to pick */}
      <Composition id="bible-decoder-concept-a-evidence-board" component={ConceptA_EvidenceBoard} fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bible-decoder-concept-b-manuscript-margin" component={ConceptB_ManuscriptMargin} fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bible-decoder-concept-c-forensic-lower-third" component={ConceptC_ForensicLowerThird} fps={FPS} width={W} height={H} durationInFrames={90} />

      {/* Bible Mysteries Decoder — full kit showcase (Concept C look, grouped for review) */}
      <Composition id="bd-kit-reveal-beats"   component={Showcase_RevealBeats}   fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bd-kit-info-beats"     component={Showcase_InfoBeats}     fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bd-kit-special-beats"  component={Showcase_SpecialBeats}  fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bd-kit-quote"          component={Showcase_QuoteAndMyth}  fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bd-kit-mythbust"       component={Showcase_MythBust}      fps={FPS} width={W} height={H} durationInFrames={90} />
      <Composition id="bd-kit-chapter"        component={Showcase_Chapter}       fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bd-kit-endcard"        component={Showcase_EndCard}       fps={FPS} width={W} height={H} durationInFrames={60} />

      {/* FINAL simplified set — bright W01 Sinai plate, legibility stress test */}
      <Composition id="w01-overlay-test-citation" component={W01_OverlayTest_Citation} fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="w01-overlay-test-reveal"   component={W01_OverlayTest_Reveal}   fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="w01-overlay-test-both"     component={W01_OverlayTest_Both}     fps={FPS} width={W} height={H} durationInFrames={60} />

      {/* BuriedVerse — warm/diorama reskin proofs on REAL E01 (25221141) anchor plates */}
      <Composition id="bv-demo-1-word"     component={BV_Demo1_Word}     fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-demo-2-citation" component={BV_Demo2_Citation} fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-demo-3-place"    component={BV_Demo3_Place}    fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-demo-4-myth"     component={BV_Demo4_Myth}     fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-demo-5-both"     component={BV_Demo5_Both}     fps={FPS} width={W} height={H} durationInFrames={60} />

      {/* BuriedVerse — diorama-native CONCEPTS, same plate + same copy for a fair compare */}
      <Composition id="bv-concept-a" component={BV_ConceptA_Specimen}   fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-concept-b" component={BV_ConceptB_CaptionBand} fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-concept-c" component={BV_ConceptC_PinnedTag}   fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-concept-d" component={BV_ConceptD_R1Fixed}     fps={FPS} width={W} height={H} durationInFrames={60} />

      {/* BuriedVerse — REAL logo candidates, 70px @720p, top:20 right:20 (Jyotirlinga padding) */}
      <Composition id="bv-logo-1-concept1" component={BV_Logo1_Concept1} fps={FPS} width={W} height={H} durationInFrames={60} />
      <Composition id="bv-logo-2-diorama"  component={BV_Logo2_Diorama}  fps={FPS} width={W} height={H} durationInFrames={60} />

      {/* BuriedVerse E01 full overlay comp. fps=16 ON PURPOSE — the assembled base is 16fps.
          Do NOT use the shared FPS const (24) here or every anchor slides 1.5x. */}
      <Composition
        id="buriedverse-e01-overlays"
        component={BuriedVerseE01Overlays}
        fps={E01_FPS}
        width={W}
        height={H}
        durationInFrames={E01_DURATION_FRAMES}
      />

      {/* BuriedVerse E01 — 4K route. fps=24 to match the Topaz base (Apollo 16→24).
          Rendered at --scale=3 → 3840x2112. showLogo=false: the diorama mark is added
          full-runtime by ffmpeg in modal composite() (cluster render can't carry it). */}
      <Composition
        id="buriedverse-e01-overlays-4k"
        component={BuriedVerseE01Overlays}
        fps={E01_FPS_4K}
        width={W}
        height={H}
        durationInFrames={E01_DURATION_FRAMES_4K}
        defaultProps={{ showLogo: false }}
      />

      {/* BuriedVerse E02 "Rapture" — 16fps preview + 24fps 4K (devotional route). */}
      <Composition id="buriedverse-e02-overlays" component={BuriedVerseE02RaptureOverlays}
        fps={e02_rapture_FPS} width={W} height={H} durationInFrames={e02_rapture_DURATION_FRAMES} />
      <Composition id="buriedverse-e02-overlays-4k" component={BuriedVerseE02RaptureOverlays}
        fps={e02_rapture_FPS_4K} width={W} height={H} durationInFrames={e02_rapture_DURATION_FRAMES_4K}
        defaultProps={{ showLogo: false }} />

      {/* BuriedVerse E03 "Prodigal" — 16fps preview + 24fps 4K (devotional route). */}
      <Composition id="buriedverse-e03-overlays" component={BuriedVerseE03ProdigalOverlays}
        fps={e03_prodigal_FPS} width={W} height={H} durationInFrames={e03_prodigal_DURATION_FRAMES} />
      <Composition id="buriedverse-e03-overlays-4k" component={BuriedVerseE03ProdigalOverlays}
        fps={e03_prodigal_FPS_4K} width={W} height={H} durationInFrames={e03_prodigal_DURATION_FRAMES_4K}
        defaultProps={{ showLogo: false }} />

      {/* BuriedVerse E04 "Shalom" — 16fps preview + 24fps 4K (devotional route). */}
      <Composition id="buriedverse-e04-overlays" component={BuriedVerseE04ShalomOverlays}
        fps={e04_shalom_FPS} width={W} height={H} durationInFrames={e04_shalom_DURATION_FRAMES} />
      <Composition id="buriedverse-e04-overlays-4k" component={BuriedVerseE04ShalomOverlays}
        fps={e04_shalom_FPS_4K} width={W} height={H} durationInFrames={e04_shalom_DURATION_FRAMES_4K}
        defaultProps={{ showLogo: false }} />

      {/* BuriedVerse E05 "Hell" — 16fps preview + 24fps 4K (devotional route).
          ⚠️ durationInFrames are PROVISIONAL (episode not assembled yet; est. from duration_sec
          + ~6.5s tail). Re-set from the base ffprobe once e05_hell_*_final.mp4 exists. */}
      <Composition id="buriedverse-e05-overlays" component={BuriedVerseE05HellOverlays}
        fps={e05_hell_FPS} width={W} height={H} durationInFrames={e05_hell_DURATION_FRAMES} />
      <Composition id="buriedverse-e05-overlays-4k" component={BuriedVerseE05HellOverlays}
        fps={e05_hell_FPS_4K} width={W} height={H} durationInFrames={e05_hell_DURATION_FRAMES_4K}
        defaultProps={{ showLogo: false }} />

      {/* BuriedVerse — SUBSCRIBE / COMMENT CTA candidates. 1280x704 @16fps (the channel base).
          Right-middle band (x 834-1234, y 186-326): clear of BvFactTag (top-left 700x340),
          BvHero (bottom band y404+) and BvLogo (top-right). Fact tag + hero are live in each
          plate so the no-collision claim is visible, not just asserted. */}
      <Composition id="bv-cta-a-subscribe" component={BvCtaA_Subscribe} fps={16} width={W} height={H} durationInFrames={96} />
      <Composition id="bv-cta-a-comment"   component={BvCtaA_Comment}   fps={16} width={W} height={H} durationInFrames={96} />
      <Composition id="bv-cta-b-subscribe" component={BvCtaB_Subscribe} fps={16} width={W} height={H} durationInFrames={96} />
      <Composition id="bv-cta-b-comment"   component={BvCtaB_Comment}   fps={16} width={W} height={H} durationInFrames={96} />
      <Composition id="bv-cta-c-subscribe" component={BvCtaC_Subscribe} fps={16} width={W} height={H} durationInFrames={96} />
      <Composition id="bv-cta-c-comment"   component={BvCtaC_Comment}   fps={16} width={W} height={H} durationInFrames={96} />

      {/* Preview compositions */}
      <Composition id="preview-all" component={OverlayManifest} fps={FPS} width={W} height={H}
        durationInFrames={192} defaultProps={{ manifest: previewManifest }} />

      {/* ── FINALS ── */}
      {(() => {
        const compressed = compressManifest(kedarnathRaw as OverlayManifestData);
        const frames = Math.ceil((compressed.total_duration_ms / 1000) * FPS);
        return (
          <Composition
            id="final-kedarnath-compressed"
            component={OverlayManifest}
            fps={FPS} width={W} height={H}
            durationInFrames={frames}
            defaultProps={{ manifest: compressed }}
          />
        );
      })()}
      <Composition id="final-scenario-30s" component={ScenarioPreview} fps={FPS} width={W} height={H} durationInFrames={SCENARIO_TOTAL} />
      <Composition id="final-quote-shift" component={QuoteShiftPreview} fps={FPS} width={W} height={H} durationInFrames={QS_TOTAL} />
      <Composition id="final-year-infobox-overlap" component={YearInfoOverlapPreview} fps={FPS} width={W} height={H} durationInFrames={YIP_TOTAL} />
      <Composition id="final-six-tags"          component={SixTagsPreview}         fps={FPS} width={W} height={H} durationInFrames={204} />
      <Composition id="final-six-location-tags" component={SixLocationTagsPreview} fps={FPS} width={W} height={H} durationInFrames={204} />
      <Composition id="final-year-stamp-hindi"  component={YearStampHindiPreview}  fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="final-scripture-ref" component={ScriptureRef} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }, durationInFrames: 72 }} />
      <Composition id="final-quote-card-a" component={QuoteCardA} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }, durationInFrames: 72 }} />
      <Composition id="final-info-box-c" component={InfoBoxC} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { label: "BHAIRON JHAP", label_hindi: "भैरों झाप", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }, durationInFrames: 72 }} />
      <Composition id="final-stat-card" component={StatCard} fps={FPS} width={W} height={H} durationInFrames={96}
        defaultProps={{ data: { stats: [
          { label: "Altitude", value: "3,583m", value_secondary: "11,755 ft" },
          { label: "Established", value: "8th Century" },
          { label: "Pilgrims / Year", value: "~10 Lakh" },
        ] }, durationInFrames: 96 }} />

      <Composition id="final-kedarnath-end-card" component={KedarnathEndCard} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 10)} />
      <Composition id="shivling-cta" component={ShivlingCTA} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 12)} />
      <Composition id="har-har-mahadev-cta" component={HarHarMahadevCTA} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 7)} />
      <Composition id="jai-somnath-cta" component={JaiSomnathCTA} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 7)} />
      <Composition id="har-har-gange-cta" component={HarHarGangeCTA} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 7)} />

      {/* ── Factory Decoder CTAs (English, transparent, 1280×704 @ 24fps) ── */}
      <Composition id="cta-subscribe-bell" component={CTASubscribeBell} fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 5)} />
      <Composition id="cta-like"           component={CTALike}         fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 5)} />
      <Composition id="cta-share"          component={CTAShare}        fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 5)} />
      <Composition id="cta-combined-bar"   component={CTACombinedBar}  fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 5)} />
      <Composition id="cta-lower-third"    component={CTALowerThird}   fps={FPS} width={W} height={H} durationInFrames={Math.round(FPS * 5)} />

      {/* Devotional Reel overlay — portrait 1080x1440, transparent, for WhatsApp/Instagram reels */}
      <Composition id="devotional-reel-overlay" component={DevotionalReelOverlay} fps={30} width={1080} height={1440} durationInFrames={300} />

      {/* MantraCard — Badrinath closing mantra "जय बद्री विशाल" */}
      <Composition
        id="mantra-card-badrinath-1"
        component={MantraCardBadrinath1}
        fps={FPS} width={W} height={H}
        durationInFrames={197}
        defaultProps={{
          data: {
            words: [
              { word: "जय",    offset_ms: 0    },
              { word: "बद्री", offset_ms: 302  },
              { word: "विशाल", offset_ms: 1916 },
            ],
          },
          durationInFrames: 197,
        }}
      />

      {/* Kedarnath rendered overlays WebM */}
      <Composition id="kedarnath-overlays-webm" component={() => <OffthreadVideo src={staticFile('previews/kedarnath_overlays.webm')} style={{ width: '100%', height: '100%' }} />} fps={FPS} width={W} height={H} durationInFrames={13990} />

      {/* ── DEV / VARIANTS ── */}
      {/* ── SANATAN CINEMATICS · 4K 30fps · name LEFT, place RIGHT ── */}
      <Composition id="sc-group-overlay" component={SanatanGroupOverlay} fps={SC_FPS} width={SC_W} height={SC_H}
        durationInFrames={300} defaultProps={SC_GROUP_DEMO} calculateMetadata={scGroupMetadata} />
      <Composition id="sc-group-demo"    component={SCGroupDemo}        fps={SC_FPS} width={SC_W} height={SC_H}
        durationInFrames={Math.round(27.17 * SC_FPS)} />
      <Composition id="sc-tags"      component={SCTagsPreview}     fps={SC_FPS} width={SC_W} height={SC_H} durationInFrames={120} />
      <Composition id="sc-two-names" component={SCTwoNamesPreview} fps={SC_FPS} width={SC_W} height={SC_H} durationInFrames={150} />

      <Composition id="person-tag" component={PersonTagPreview} fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="two-person-tags"    component={TwoTagsPreview}    fps={FPS} width={W} height={H} durationInFrames={192} />
      <Composition id="replace-tags"       component={ReplaceTagsPreview} fps={FPS} width={W} height={H} durationInFrames={168} />
      <Composition id="six-tags"           component={SixTagsPreview}          fps={FPS} width={W} height={H} durationInFrames={204} />
      <Composition id="six-location-tags"  component={SixLocationTagsPreview}  fps={FPS} width={W} height={H} durationInFrames={204} />

      <Composition id="location-tag" component={LocationTag} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { name: "Madhyamaheshwar", name_hindi: "मध्यमहेश्वर", detail: "Manifestation of Shiva's Navel (Nabhi)" }, durationInFrames: 72 }} />

      <Composition id="year-stamp-hindi"  component={YearStampHindiPreview}  fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="year-stamp-latin"  component={YearStampLatinPreview}  fps={FPS} width={W} height={H} durationInFrames={72} />
      <Composition id="two-year-stamps"   component={TwoYearStampsPreview}   fps={FPS} width={W} height={H} durationInFrames={96} />

      <Composition id="scripture-ref-a" component={ScriptureRef}  fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }, durationInFrames: 72 }} />
      <Composition id="scripture-ref-b" component={ScriptureRefB} fps={FPS} width={W} height={H} durationInFrames={120}
        defaultProps={{ data: { scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }, durationInFrames: 120 }} />
      <Composition id="scripture-ref-c" component={ScriptureRefC} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { scripture: "Mahabharata", section: "Van Parva (Tirtha Yatra Parva), Section 85" }, durationInFrames: 72 }} />

      <Composition id="quote-card" component={QuoteCard} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }, durationInFrames: 72 }} />
      <Composition id="quote-card-a" component={QuoteCardA} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { text: "यहाँ स्नान करने से एक हज़ार गायों के दान का पुण्य मिलता है", source: "Mahabharata — Van Parva", translation: "Bathing here grants merit equal to donating one thousand cows" }, durationInFrames: 72 }} />

      <Composition id="info-box-orig" component={InfoBox}  fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { label: "BHAIRON JHAP", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }, durationInFrames: 72 }} />
      <Composition id="info-box-a" component={InfoBoxA} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { label: "BHAIRON JHAP", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }, durationInFrames: 72 }} />
      <Composition id="info-box-b" component={InfoBoxB} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { label: "BHAIRON JHAP", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }, durationInFrames: 72 }} />
      <Composition id="info-box-c" component={InfoBoxC} fps={FPS} width={W} height={H} durationInFrames={72}
        defaultProps={{ data: { label: "BHAIRON JHAP", label_hindi: "भैरों झाप", text: "A steep cliff near Mahapanth where devotees historically jumped to attain instant Moksha.", text_hindi: "महापंथ के पास एक खड़ी चट्टान जहाँ से लोग मोक्ष के लिए कूदते थे" }, durationInFrames: 72 }} />

      <Composition id="stat-card" component={StatCard} fps={FPS} width={W} height={H} durationInFrames={96}
        defaultProps={{ data: { stats: [
          { label: "Altitude", value: "3,583m", value_secondary: "11,755 ft" },
          { label: "Established", value: "8th Century" },
          { label: "Pilgrims / Year", value: "~10 Lakh" },
        ] }, durationInFrames: 96 }} />

      {/* ── Portrait Reel Overlays (720×1280 @ 16fps) ── */}
      <Composition id="reel-logo-watermark" component={LogoWatermark}
        fps={RFPS} width={RW} height={RH} durationInFrames={160} />
      <Composition id="reel-title-stamp" component={ReelTitleStamp}
        fps={RFPS} width={RW} height={RH} durationInFrames={192}
        defaultProps={{ text: "JAI KEDARNATH" }} />
      <Composition id="reel-watch-full-cta" component={WatchFullCTA}
        fps={RFPS} width={RW} height={RH} durationInFrames={50} />
      {/* CTA variants (48 frames = 3s @ 16fps) */}
      <Composition id="reel-cta-1" component={ReelCTA1} fps={RFPS} width={RW} height={RH} durationInFrames={50} />
      <Composition id="reel-cta-2" component={ReelCTA2} fps={RFPS} width={RW} height={RH} durationInFrames={50} />
      <Composition id="reel-cta-3" component={ReelCTA3} fps={RFPS} width={RW} height={RH} durationInFrames={50} />
      <Composition id="reel-cta-4" component={ReelCTA4} fps={RFPS} width={RW} height={RH} durationInFrames={50} />
      {/* Like/Subscribe variants (96 frames = 6s @ 16fps) */}
      <Composition id="reel-ls-1" component={ReelLS1} fps={RFPS} width={RW} height={RH} durationInFrames={96} />
      <Composition id="reel-ls-2" component={ReelLS2} fps={RFPS} width={RW} height={RH} durationInFrames={96} />
      <Composition id="reel-ls-3" component={ReelLS3} fps={RFPS} width={RW} height={RH} durationInFrames={96} />
      <Composition id="reel-ls-4" component={ReelLS4} fps={RFPS} width={RW} height={RH} durationInFrames={96} />
      {/* Free-position text overlay (160 frames = 10s @ 16fps) */}
      <Composition id="reel-text-overlay" component={ReelTextOverlay}
        fps={RFPS} width={RW} height={RH} durationInFrames={160}
        defaultProps={{ text: "JAI KEDARNATH", topPct: 10, durationInFrames: 160 }}
        calculateMetadata={async ({ props }: { props: { durationInFrames: number } }) => ({
          durationInFrames: props.durationInFrames || 160,
        })} />
      <Composition id="reel-dual-text-box" component={ReelDualTextBox}
        fps={RFPS} width={RW} height={RH} durationInFrames={160}
        defaultProps={{ text: "Box 1", bottomPct: 25, durationInFrames: 160 }}
        calculateMetadata={async ({ props }: { props: { durationInFrames: number } }) => ({
          durationInFrames: props.durationInFrames || 160,
        })} />
      <Composition id="reel-dual-cta" component={ReelDualCTA}
        fps={RFPS} width={RW} height={RH} durationInFrames={160}
        defaultProps={{ durationInFrames: 160 }}
        calculateMetadata={async ({ props }: { props: { durationInFrames: number } }) => ({
          durationInFrames: props.durationInFrames || 160,
        })} />
      <Composition id="reel-creator-cut-caption" component={CreatorCutCaption}
        fps={RFPS} width={RW} height={RH} durationInFrames={160}
        defaultProps={{ words: [], durationInFrames: 160 }}
        calculateMetadata={async ({ props }: { props: { words: unknown[]; durationInFrames: number } }) => ({
          durationInFrames: props.durationInFrames || 160,
        })} />

      {/* ── 3:4 (960×1280) lyric ROLLER caption — music channel (deva_katha_music) only ── */}
      <Composition id="reel-roller-caption" component={ReelRollerCaption}
        fps={RFPS} width={960} height={1280} durationInFrames={160}
        defaultProps={{ lines: [], durationInFrames: 160 }}
        calculateMetadata={async ({ props }: { props: { lines: unknown[]; durationInFrames: number } }) => ({
          durationInFrames: props.durationInFrames || 160,
        })} />

      {/* ── "Watch full video on YouTube" CTA — small icon + text on alpha (3:4) ── */}
      <Composition id="reel-youtube-cta" component={ReelYouTubeCTA}
        fps={RFPS} width={960} height={1280} durationInFrames={96}
        defaultProps={{ bottomPct: 4, durationInFrames: 96 }}
        calculateMetadata={async ({ props }: { props: { durationInFrames?: number } }) => ({
          durationInFrames: props.durationInFrames || 96,
        })} />


      {/* ── Chocolate overlay preview (6 overlays + 5 gaps, 720f @ 16fps) ── */}
      <Composition
        id="chocolate-preview"
        component={ChocolatePreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={720}
      />

      {/* ── Trimbakeshwar Part A overlays — top-left phrase animations, keyword pop ── */}
      <Composition
        id="trimbak-partA"
        component={TrimbakeshwarOverlays}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={1384}
        defaultProps={{ phrases: TRIMBAK_A }}
      />

      {/* ── Trimbakeshwar OPENER title card — center, big, fade in/out, last 3s of 19s opener ── */}
      <Composition
        id="trimbak-opener-title"
        component={TrimbakeshwarOpenerTitle}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={304}
        defaultProps={{ text: "जय त्र्यंबकेश्वर! 🚩", startS: 16.0, endS: 18.8, fontSize: 104, color: "y" }}
      />

      {/* ── Trimbakeshwar Part B overlays — story half (86.45→end) ── */}
      <Composition
        id="trimbak-partB"
        component={TrimbakeshwarOverlays}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={13366}
        defaultProps={{ phrases: TRIMBAK_B }}
      />

      {/* ── Krishna ki mrityu Part A overlays — TL default, BL/LowerThird exceptions ── */}
      <Composition
        id="krishna-partA"
        component={KrishnaOverlays}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={554}
        defaultProps={{ phrases: KRISHNA_A }}
      />

      {/* ── Krishna ki mrityu Part B overlays — 12 phrases, ~463s + headroom for ramp=1 shift + freeze tail ── */}
      <Composition
        id="krishna-partB"
        component={KrishnaOverlays}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={7600}
        defaultProps={{ phrases: KRISHNA_B }}
      />

      {/* ── Chocolate FULL — transparent word-synced overlays, composited onto footage ── */}
      <Composition
        id="chocolate-full"
        component={ChocolateFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={11456}
      />

      {/* ── Coca-Cola FULL — transparent word-synced overlays for 640.35s base video ── */}
      <Composition
        id="coca-cola-full"
        component={CocaColaFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={10256}
      />

      {/* ── Money FULL — transparent word-synced overlays for 664.612s base video ── */}
      <Composition
        id="money-full"
        component={MoneyFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={10650}
      />

      {/* ── Lay's FULL — transparent word-synced overlays for 758.922s base video ── */}
      <Composition
        id="lays-full"
        component={LaysFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={12159}
      />

      {/* ── Uranium Segment 1 trial — transparent overlays for the 14.625s hook segment ── */}
      <Composition
        id="uranium-seg1"
        component={UraniumSeg1}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={234}
      />

      {/* ── Uranium Segments 2+3 — universal bottom-left tags over the full 40.1s timeline ── */}
      <Composition
        id="uranium-seg23"
        component={UraniumSeg23}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={642}
      />

      {/* ── Uranium FULL — Part 1 (clamped) + Parts 2–3 + Parts 4–54 universal tags, full 713.713s timeline ── */}
      <Composition
        id="uranium-full"
        component={UraniumFull}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={11456}
      />

      {/* ── Coca-Cola Factory Files — 81 Remotion Templates ── */}
      <Composition id="cc-animated-list"           component={AnimatedList}          fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-animated-text"           component={AnimatedText}          fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-area-chart"              component={AreaChart}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-blinds-transition"       component={BlindsTransition}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-bokeh-circles"           component={BokehCircles}          fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-bounce-text"             component={BounceText}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-bubble-pop-text"         component={BubblePopText}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-camera-shake"            component={CameraShake}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-card-flip"               component={CardFlip}              fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-chapter-title"           component={ChapterTitle}          fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-chart-animation"         component={ChartAnimation}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-cinematic-title-intro"   component={CinematicTitleIntro}   fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-circular-progress"       component={CircularProgress}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-clock-wipe"              component={ClockWipe}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-comparison-chart"        component={ComparisonChart}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-countdown-intro"         component={CountdownIntro}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-countdown-timer"         component={CountdownTimer}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-credits-roll"            component={CreditsRoll}           fps={24} width={1280} height={704} durationInFrames={240} />
      <Composition id="cc-cross-dissolve"          component={CrossDissolve}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-donut-chart"             component={DonutChart}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-end-card"                component={EndCard}               fps={24} width={1280} height={704} durationInFrames={240} />
      <Composition id="cc-fade-through-black"      component={FadeThroughBlack}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-film-burn"               component={FilmBurn}              fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-floating-bubble-text"    component={FloatingBubbleText}    fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-gallery-grid"            component={GalleryGrid}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-geometric-patterns"      component={GeometricPatterns}     fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-glitch-text"             component={GlitchText}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-gradient-shift"          component={GradientShift}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-grid-pulse"              component={GridPulse}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-image-carousel"          component={ImageCarousel}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-image-comparison-slider" component={ImageComparisonSlider} fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-image-zoom-reveal"       component={ImageZoomReveal}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-iris-transition"         component={IrisTransition}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-ken-burns"               component={KenBurns}              fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-letterbox-reveal"        component={LetterboxReveal}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-line-chart"              component={LineChart}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-liquid-wave"             component={LiquidWave}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-blur-reveal"        component={LogoBlurReveal}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-bounce-drop"        component={LogoBounceDrop}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-fade-reveal"        component={LogoFadeReveal}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-glitch-reveal"      component={LogoGlitchReveal}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-scale-rotate"       component={LogoScaleRotate}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-spin-reveal"        component={LogoSpinReveal}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-split-reveal"       component={LogoSplitReveal}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-stroke-draw"        component={LogoStrokeDraw}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-logo-typewriter"         component={LogoTypewriter}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-lower-third"             component={LowerThird}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-masonry-gallery"         component={MasonryGallery}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-matrix-rain"             component={MatrixRain}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-morph-transition"        component={MorphTransition}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-noise-grain"             component={NoiseGrain}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-notification-pop"        component={NotificationPop}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-parallax-pan"            component={ParallaxPan}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-particle-explosion"      component={ParticleExplosion}     fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-photo-stack"             component={PhotoStack}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-picture-in-picture"      component={PictureInPicture}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-pie-chart"               component={PieChart}              fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-pixel-transition"        component={PixelTransition}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-polaroid-frame"          component={PolaroidFrame}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-popping-text"            component={PoppingText}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-progress-bars"           component={ProgressBars}          fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-progress-steps"          component={ProgressSteps}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-pulsing-text"            component={PulsingText}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-push-transition"         component={PushTransition}        fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-quote-card-template"     component={QuoteCardTemplate}     fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-rotating-carousel"       component={RotatingCarousel}      fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-slide-text"              component={SlideText}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-slide-wipe"              component={SlideWipe}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-sound-wave"              component={SoundWave}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-split-screen"            component={SplitScreen}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-spotlight-reveal"        component={SpotlightReveal}       fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-starfield"               component={Starfield}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-stat-counter"            component={StatCounter}           fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-subscribe-reminder"      component={SubscribeReminder}     fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-text-highlight"          component={TextHighlight}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-title-split"             component={TitleSplit}            fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-typewriter-subtitle"     component={TypewriterSubtitle}    fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-vignette-pulse"          component={VignettePulse}         fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-whip-pan"                component={WhipPan}               fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-zoom-pulse"              component={ZoomPulse}             fps={24} width={1280} height={704} durationInFrames={120} />
      <Composition id="cc-zoom-through"            component={ZoomThrough}           fps={24} width={1280} height={704} durationInFrames={120} />
          {/* ─── overlay_implementer auto-compositions ─── */}
      {/* 24fps to match the Topaz 4K base (reconcat_base asserts /24.0).
          Every time inside the comp is S(seconds), so it is fps-safe. */}
      <Composition
        id="bible-decoder-w01-overlays"
        component={BibleDecoderW01Overlays}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={31835}
      />
      {/* W02 Luther & W03 Sodom — 24fps to match the Topaz 4K base (factory_4k_full
          reconcat asserts /24.0), same as W01. Every time inside is S(seconds), so the
          SAME comp is fps-safe and also composites onto the 720p 16fps final for preview. */}
      <Composition
        id="bible-decoder-w02-overlays"
        component={BibleDecoderW02Overlays}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={35968}
      />
      <Composition
        id="bible-decoder-w03-overlays"
        component={BibleDecoderW03Overlays}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={30984}
      />
      <Composition
        id="JagannathFullPreview"
        component={JagannathFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={31250}
      />
      <Composition
        id="CamphorFullPreview"
        component={CamphorFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={10451}
      />
      <Composition
        /* ffu_dam / Machine Room — registered TWICE, the same as every Deva Katha and
           bible-decoder production (nirjala-overlays 16 + nirjala-overlays-4k 24, etc).
           The component is fps-safe (every anchor derives from useVideoConfig().fps), so
           one source file serves both. */
        id="FfuDamFullPreview"          /* 0.5x preview — composites onto the 16fps 720p final */
        component={FfuDamFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={10533}        /* ceil(658.312 x 16) */
      />
      <Composition
        /* THE 4K ID — this is what overlay_windows/ffu_dam.json and productions
           .overlay_design_spec.comp must point at. modal_factory_render.py::factory_4k_full
           hardcodes FPS=24 because the Topaz base is Apollo-interpolated 16->24fps. Pointing
           the 4K route at the 16fps id failed every cluster past frame 10532
           ("frame range 12634-12962 is not inbetween 0-10532") and mistimed the rest. */
        id="ffu-dam-overlays-4k"
        component={FfuDamFullPreview}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={15800}        /* ceil(658.312 x 24); factory_4k_full MAXF = 15791 */
      />
      <Composition
        id="MomosFullPreview"
        component={MomosFullPreview}
        fps={24}
        width={1280}
        height={704}
        durationInFrames={15641}
      />
      <Composition
        id="MaggiFullPreview"
        component={MaggiFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={13872}
      />
      <Composition
        id="MaggiSubCoverPreview"
        component={MaggiSubCoverPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={64}
      />
      <Composition
        id="monster-energy-full"
        component={MonsterEnergyFull}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={10034}
      />
      <Composition
        id="sting-full"
        component={StingFullPreview}
        fps={16}
        width={1280}
        height={704}
        durationInFrames={9824}
      />
      {/* Sanatan Decode — Vox-style kit proof, 20s @ 30fps 720p */}
      <Composition
        id="sanatan-decode-gotra-proof"
        component={SanatanDecodeGotraProof}
        fps={30}
        width={1280}
        height={720}
        durationInFrames={600}
      />
      {/* ⭐ v19 ACT 1 — hand-authored at v9 density (word-by-word type, travelling objects,
          light sweeps). 78s proof before rolling the same treatment across all 25 beats. */}
      <Composition id="gotra-v19-act1" component={SanatanDecodeGotraV19}
        fps={16} width={854} height={480} durationInFrames={1250} />
      {/* WebGL smoke test — DISABLED, see the Gl3dSmoke import note at the top.
      <Composition id="gl3d-smoke" component={Gl3dSmoke}
        fps={24} width={1280} height={720} durationInFrames={24} /> */}
      <Composition id="font-probe" component={FontProbe}
        fps={24} width={1500} height={860} durationInFrames={1} />
      {/* ⭐ गोत्र 45s — four completely different style versions on the same Charon narration.
          45.6s @ 24fps = 1095 frames. Preview at 1280x720. */}
      <Composition id="gotra45-A-deepfield" component={VerA_DeepField}
        fps={24} width={1280} height={720} durationInFrames={1095} />
      <Composition id="gotra45-B-archive" component={VerB_Archive}
        fps={24} width={1280} height={720} durationInFrames={1095} />
      <Composition id="gotra45-C-type" component={VerC_Type}
        fps={24} width={1280} height={720} durationInFrames={1095} />
      <Composition id="gotra45-D-delta" component={VerD_Delta}
        fps={24} width={1280} height={720} durationInFrames={1095} />
      {/* ⭐ गोत्र 45s — "LIT ARCHIVE", hand-authored 2026-08-15. Fresh build; shares
          nothing with A-D. 45.648s @ 24fps = 1096 frames. */}
      <Composition id="gotra45-lit-archive" component={Gotra45}
        fps={24} width={1280} height={720} durationInFrames={1096} />
      {/* ⭐ v18 — EP01. v17 rejected: wrong WTS, overlapping props, blank frames, 5 of 6 occasions.
          Now on globally force-aligned timing, width-packed prop rows, accumulating props. */}
      {/* ⭐ विष्णु स्मृति flow beat — cut from ONE gpt-image plate into 9 alpha layers. */}
      {/* ⭐ v20 गोत्र EP01 master comp — 24 fps 1080p, 13050 frames; assets in public_gotra_v20 (render with --public-dir=/app/public_gotra_v20) */}
      <Composition id="gotra-v20" component={GotraV20} fps={24} width={1920} height={1080} durationInFrames={13050} />
      <Composition id="vishnu-smriti-flow" component={VishnuSmritiFlow}
        fps={30} width={1920} height={1080} durationInFrames={240} />
      <Composition id="sanatan-decode-gotra-v18" component={SanatanDecodeGotraV18}
        fps={16} width={640} height={360} durationInFrames={8704} />
      <Composition id="sanatan-decode-gotra-v18-720" component={SanatanDecodeGotraV18}
        fps={30} width={1280} height={720} durationInFrames={16320} />
      {/* ⭐ v17 "THE MAP" — EP01 FULL EPISODE 9:04. Organic descent map + full cast retained,
          static ground that travels only across cuts, type force-aligned to the real narration.
          Authored at 720p; render 480p with --scale=0.6667 (see §dynamic factor). */}
      <Composition id="sanatan-decode-gotra-v17" component={SanatanDecodeGotraV17}
        fps={30} width={1280} height={720} durationInFrames={16320} />
      {/* ⭐ PROOF SIZE — half of 720p (640x360) at 16fps. Same component: the Stage wrapper rescales
          the 720p-authored layout, and the timing helpers read fps off the composition, so nothing
          is re-tuned. 8704 frames vs 16320 = roughly half the render. */}
      <Composition id="sanatan-decode-gotra-v17-360" component={SanatanDecodeGotraV17}
        fps={16} width={640} height={360} durationInFrames={8704} />
      {/* v16 "SPLIT" — तब | अब: two live panoramas, the divider slides to say which side the argument is on */}
      <Composition id="sanatan-decode-gotra-v16" component={SanatanDecodeGotraV16}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v15 "POSTER" — bold flat colour field per beat, 96-132px type, panorama survives only through a moving aperture */}
      <Composition id="sanatan-decode-gotra-v15" component={SanatanDecodeGotraV15}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v14 "TREE" — the film is ONE diagram: descent tree draws, puts two leaves on trial, hands them to the science beat */}
      <Composition id="sanatan-decode-gotra-v14" component={SanatanDecodeGotraV14}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v13 "RIGGED" — v10 layout, figures rigged into phase-lagged bands so they breathe and sway instead of swinging as slabs */}
      <Composition id="sanatan-decode-gotra-v13" component={SanatanDecodeGotraV13}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v12 "EVIDENCE" — register split: flat illustration = the claim, photoreal sticker = the proof */}
      <Composition id="sanatan-decode-gotra-v12" component={SanatanDecodeGotraV12}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v11 "PAPER" — v10 motion, collage MATERIAL: every cutout + headline pasted on a hand-torn card, one bold flat field per beat */}
      <Composition id="sanatan-decode-gotra-v11" component={SanatanDecodeGotraV11}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v10 — v9 + ASYMMETRIC WALK: fast L→R sprint across every beat transition, slow R→L reclaim while a beat is resident */}
      <Composition id="sanatan-decode-gotra-v10" component={SanatanDecodeGotraV10}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v9 — v8 + the generation chain putra/pautra/prapautra/kai peedhi -> aap */}
      <Composition id="sanatan-decode-gotra-v9" component={SanatanDecodeGotraV9}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v8 — one 3:1 panorama, walked; background pushed back optically */}
      <Composition id="sanatan-decode-gotra-v8" component={SanatanDecodeGotraV8}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v7 — v5 with the gurukul ground */}
      <Composition id="sanatan-decode-gotra-v7" component={SanatanDecodeGotraV7}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v6 — photoreal live ground, no dots/shapes */}
      <Composition id="sanatan-decode-gotra-v6" component={SanatanDecodeGotraV6}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v5 — on twos, object permanence, graphic match, one accent, anchor-first */}
      <Composition id="sanatan-decode-gotra-v5" component={SanatanDecodeGotraV5}
        fps={30} width={1280} height={720} durationInFrames={632} />
      {/* v4 — swing physics, background shifts + arriving/leaving bg elements, camera */}
      <Composition
        id="sanatan-decode-gotra-v4"
        component={SanatanDecodeGotraV4}
        fps={30}
        width={1280}
        height={720}
        durationInFrames={632}
      />
      {/* v3 — Deva Katha voice, WTS-anchored text, Sanatan ornament. 19.57s audio + tail */}
      <Composition
        id="sanatan-decode-gotra-v3"
        component={SanatanDecodeGotraV3}
        fps={30}
        width={1280}
        height={720}
        durationInFrames={632}
      />
      {/* v2 — light paper ground + gpt-image-2 cutouts */}
      <Composition
        id="sanatan-decode-gotra-v2"
        component={SanatanDecodeGotraV2}
        fps={30}
        width={1280}
        height={720}
        durationInFrames={600}
      />
      <Composition
        id="murti-zoom-out"
        component={MurtiZoomOut}
        fps={24}
        width={1344}
        height={768}
        durationInFrames={158}
      />
      {/* sanatan-decode-episode: gotra_ep01_v21 — 24 fps 1080p; render with --public-dir=/app/public_gotra_ep01_v21 */}
      <Composition id="gotra-ep01-v21" component={Ep_gotra_ep01_v21} fps={24} width={1920} height={1080} durationInFrames={13050} />
      {/* sanatan-decode-episode: pitru_paksha — 24 fps 1080p; render with --public-dir=/app/public_pitru_paksha */}
      <Composition id="pitru-paksha" component={Ep_pitru_paksha} fps={24} width={1920} height={1080} durationInFrames={12131} />
      {/* sanatan-decode-episode: pind_daan — 24 fps 1080p; render with --public-dir=/app/public_pind_daan */}
      <Composition id="pind-daan" component={Ep_pind_daan} fps={24} width={1920} height={1080} durationInFrames={10626} />
      {/* sanatan-decode-episode: kanya_pujan — 24 fps 1080p; render with --public-dir=/app/public_kanya_pujan */}
      <Composition id="kanya-pujan" component={Ep_kanya_pujan} fps={24} width={1920} height={1080} durationInFrames={14477} />
      {/* Factory Process Decoder runner CTA — 3 characters; preview = over a still of the uranium cut; transparent = for compositing */}
      <Composition id="fpd-cta-worker-preview" component={FpdCtaRunner} defaultProps={{character: "worker" as const, withBg: true}} fps={24} width={1920} height={1080} durationInFrames={FPD_CTA_FRAMES} />
      <Composition id="fpd-cta-robot-preview" component={FpdCtaRunner} defaultProps={{character: "robot" as const, withBg: true}} fps={24} width={1920} height={1080} durationInFrames={FPD_CTA_FRAMES} />
      <Composition id="fpd-cta-cog-preview" component={FpdCtaRunner} defaultProps={{character: "cog" as const, withBg: true}} fps={24} width={1920} height={1080} durationInFrames={FPD_CTA_FRAMES} />
      <Composition id="fpd-cta-worker-4k" component={FpdCtaRunner} defaultProps={{character: "worker" as const}} fps={24} width={3840} height={2160} durationInFrames={FPD_CTA_FRAMES} />
      <Composition id="fpd-cta-robot-4k" component={FpdCtaRunner} defaultProps={{character: "robot" as const}} fps={24} width={3840} height={2160} durationInFrames={FPD_CTA_FRAMES} />
      <Composition id="fpd-cta-cog-4k" component={FpdCtaRunner} defaultProps={{character: "cog" as const}} fps={24} width={3840} height={2160} durationInFrames={FPD_CTA_FRAMES} />
</>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
